import { createAction, props } from '@ngrx/store';
import { Product } from '@planone/bau365/util-fair-data';

export const productOpened = createAction('[Product Page] Opened', props<{ productUuid: string }>());
export const productOpenedUnauthorized = createAction(
  '[Product Page] Opened unauthorized',
  props<{ productUuid: string }>()
);

export const productLoadSucceeded = createAction(
  '[Product API] Product load succeeded',
  props<{ product: Product; fairId?: string }>()
);
export const productsLoadSucceeded = createAction(
  '[Product API] Products load succeeded',
  props<{ products: Product[] }>()
);
export const productLoadFailed = createAction('[Product API] Product load failed', props<{ error: string }>());
export const productsLoadFailed = createAction('[Product API] Products load failed', props<{ error: string }>());
